import { gtmSendEvent } from "@wojo/analytics";
import { useI18n } from "@wojo/localization";
import { Markdown, Text } from "@wojo/ui";
import React from "react";
import { useTourPageContext } from "../../../_client/context";

export const ContactFormSubmitted: React.FC = () => {
    const { contactConfig } = useTourPageContext();
    const { productPage } = useI18n("productPage");

    return (
        <>
            <Text.Heading
                order="5"
                tag="h3"
                data-testid="contact-success-heading"
                style={{
                    marginTop: "var(--g-spacing-md)",
                    marginBottom: "var(--g-spacing-xs)",
                }}
            >
                {productPage.tripBuilder.contactUs.successHeading.l()}
            </Text.Heading>
            <Markdown
                markdown={productPage.tripBuilder.contactUs.successDescription.l(
                    {
                        phone: `[${contactConfig?.phoneNumberFormatted}](tel:${contactConfig?.phoneNumber})`,
                    },
                )}
                onClickCapture={(e) => {
                    if (e.target instanceof HTMLAnchorElement) {
                        if (e.target.href.startsWith("tel:")) {
                            gtmSendEvent({
                                event: "track",
                                ga4Tracking: {
                                    ga4_object: "TRIP_BUILDER",
                                    ga4_action: "PHONE_CALL",
                                    phoneNumber:
                                        contactConfig?.phoneNumberFormatted ||
                                        "",
                                },
                            });
                        } else {
                            gtmSendEvent({
                                event: "track",
                                ga4Tracking: {
                                    ga4_object: "TRIP_BUILDER",
                                    ga4_action: "LINK_CLICKED",
                                    clickText: e.target.textContent || "",
                                    destinationUrl: e.target.href,
                                },
                            });
                        }
                    }
                }}
            />
        </>
    );
};
